import dayjs from "dayjs";
import { formatMoney } from "../../../../utils/util";

/* รายการ PO ค้างรับของวันที่เลือก (ใช้ในหน้าต่างรายละเอียด) */
export const poPendingColumns = ({ openPo } = {}) => [
  {
    title: "เลขที่ใบสั่งซื้อ",
    dataIndex: "pocode",
    key: "pocode",
    width: 140,
    render: (v) =>
      typeof openPo === "function" ? (
        <span
          className="cursor-pointer text-blue-600 hover:underline"
          onClick={() => openPo(v)}
        >
          {v}
        </span>
      ) : (
        v
      ),
  },
  {
    title: "วันที่สั่งซื้อ",
    dataIndex: "podate",
    key: "podate",
    width: 120,
    align: "center",
    render: (v) => (v ? dayjs(v).format("DD/MM/YYYY") : "-"),
  },
  { title: "รหัสผู้ขาย", dataIndex: "supcode", key: "supcode", width: 120 },
  { title: "ผู้ขาย", dataIndex: "supname", key: "supname", width: 220 },
  { title: "รหัสสินค้า", dataIndex: "stcode", key: "stcode", width: 130 },
  { title: "ชื่อสินค้า", dataIndex: "stname", key: "stname", width: 240 },
  {
    title: "สั่งซื้อ",
    dataIndex: "qty",
    key: "qty",
    width: 110,
    align: "right",
    render: (v) => formatMoney(Number(v || 0), 2),
  },
  {
    title: "รับแล้ว",
    dataIndex: "recamount",
    key: "recamount",
    width: 110,
    align: "right",
    render: (v) => formatMoney(Number(v || 0), 2),
  },
  {
    title: "ค้างรับ",
    dataIndex: "pending_qty",
    key: "pending_qty",
    width: 120,
    align: "right",
    render: (v) => (
      <span style={{ color: "#cf1322", fontWeight: 600 }}>
        {formatMoney(Number(v || 0), 2)}
      </span>
    ),
  },
  { title: "หน่วย", dataIndex: "unit", key: "unit", width: 90, align: "center" },
  {
    title: "สถานะ",
    dataIndex: "doc_status",
    key: "doc_status",
    width: 140,
  },
];
